module.exports = __webpack_public_path__ + "media/mediaProfessionals/pink-circle-small-6ab6d94c.png";